<template>
    <el-container class="unilateral-contral">
        <el-header>
            <Header></Header>
        </el-header>
        <el-main>
            <div class="unilateral-contral-body">
                <div class="unilateral-contral-title">{{contralTitle}}</div>
                <div class="unilateral-contral-info clearfloat" v-if="contralFlag == '1' || contralFlag == '2'">
                    <div class="unilateral-contral-item" v-for="(item, index) in contralData" :key="index">
                        <span class="contral-name">{{item[0]}}</span>
                        <span class="contral-status" :style="{'background-color': strategyStatusChanged(item[1])}"></span>
                    </div>
                </div>
                <div class="unilateral-contral-info clearfloat" v-else-if="contralFlag == '3'">
                    <div class="unilateral-contral-item" v-for="(item, index) in contralData" :key="index">
                        <span class="contral-name">{{index}}</span>
                        <span class="contral-status" :style="{'background-color': strategyStatusChanged(item)}"></span>
                    </div>
                </div>
            </div>
        </el-main>
    </el-container>
</template>

<script>
import Header from "@/components/header/Header.vue";
import { get } from "@/api/index";

export default {    
    components: {
        Header
    },
    data: function () {
        return {
            contralFlag: '',
            contralData: {}, 
            contralTitle: '',
            token: ''
        }
    },
    mounted() {
        this.contralFlag = this.$route.query.id;
        this.token = this.$cookies.get('token');
        if (this.contralFlag == '1') {
            this.contralTitle = "策略";
        } else if (this.contralFlag == '2') {
            this.contralTitle = "API";
        } else if (this.contralFlag == '3') {
            this.contralTitle = "K线";
        }

        if (this.contralFlag) {
            this.getContralData();
        }
    },
    methods: {

        // 获取数据
        getContralData() {
            var url = this.$url_LN_local + '/monitoring/detail';
            var param = {
                "token": this.token,
                "target": this.contralFlag
            };

            get(url, param).then(res => {
                if (res.code == 200) {
                    this.contralData = res.data;
                } else {
                    this.$notify.error({
                        message: res.info,
                        title: "提示",
                        offset: 100
                    })
                }
            })
            // let strategy_static = this.$router.push({
            //     path: '/unilateral/contral',
            //     query: {
            //         key: index
            //     }
            // });
        },

        // 状态 颜色判断
        strategyStatusChanged(index) {
            var index1 = String(index);
            if (index1 == '1') return '#1aa094';  // 正常
            else if (index1 == '2') return "#c32e08"; // 异常
            else if (index1 == '0') return '#333333';
        },
    }
}
</script>

<style lang="scss" scoped>
.unilateral-contral{
    color: #a8a7a9;
    .el-main {
        background-color: transparent;
        margin-top: 20px;
        padding: 0 10px;

        .contral-status{
            width: 12px;
            height: 12px;
            border-radius: 3px;
            display: inline-block;
            text-align: center;
            color: #fff;
            vertical-align: middle;
            margin-left: 5px;
        }

        .unilateral-contral-body {
            background-color: #2a2d2e;
            .unilateral-contral-title {
                padding: 10px;
                background-color: #1e1e1e;
                text-align: left;
            }
            .unilateral-contral-info {
                padding: 10px;
            }
        }
        .unilateral-contral-item {
            float: left;
            margin: 0 20px;
            background-color: #323535;
            padding: 10px;
            border-radius: 3px;
            .contral-name {
                min-width: 140px;
                display: inline-block;
                text-align: left;
                vertical-align: middle;
                height: 20px;
                font-size: 12px;
            }
        }

        .unilateral-contral-item:hover {
            background-color: #1e1e1e;
            cursor: pointer;
        }
    }
}
</style>

